import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';

import './index.css';
import App from './App';
import store from './store';
import theme from './modules/muiTheme';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    /*
      TODO: Consider re-enabling React.StrictMode
      currently it breaks local dev
    */
    //<React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>,
    //</React.StrictMode>,
  );
}
